<template>
<div class="refundDialog" v-if="dialogVisible">
    <el-dialog @close='cancel' :title="item.status==1?'确认退款':'拒绝退款'" :visible.sync="dialogVisible" width="600px">
        <el-form :model="item" :rules="rules" ref="ruleForm" label-width="80px" class="demo-ruleForm form">
            <el-form-item label="拒绝理由" prop="refundmemo" class="content">
                <el-input v-model.trim="item.refundmemo" placeholder="请输入拒绝理由" clearable></el-input>
            </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
            <el-button @click="cancel">取 消</el-button>
            <el-button type="primary" @click="submit">确 定</el-button>
        </span>
    </el-dialog>
</div>
</template>

<script>
import {uploadRefundOrderResult} from 'api/brandBusiness'
import {mapGetters, mapActions} from 'vuex'
export default {
    name: 'refundDialog',
    data() {
        return {
            dialogVisible: false,
            item: {
                refundmemo: '',
                status: 0,
                eventtype: 10,
                orderno: ''
            },
            rules: {
                refundmemo: [
                    {required: true, message: '请输入拒绝理由', trigger: 'blur'}
                ]
            }
        }
    },
    mounted() {
    },
    methods: {
        openDialog(row) {
            this.dialogVisible = true
            this.item = row
        },
        cancel() {
            this.dialogVisible = false
        },
        submit() {
            this.$refs.ruleForm.validate((valid) => {
                if (valid) {
                    this.$confirm('确认退款', '提示', {
                        confirmButtonText: '确认',
                        cancelButtonText: '取消'
                    }).then(() => {
                        this._refund(this.item)
                    })
                }
            })
        },
        _refund(obj) {
            this.setLoading(true)
            uploadRefundOrderResult({
                data: Object.assign({}, obj),
                success: data => {
                    this.setLoading(false)
                    this.$message.success('退款成功')
                    this.$emit('refresh')
                    this.cancel()
                },
                error: data => {
                    this.$message.error(data.msg)
                    this.setLoading(false)
                }
            })
        },
        ...mapActions([
            'setLoading'
        ])
    },
    filters: {},
    watch: {},
    computed: {},
    components: {}
}
</script>

<style lang="scss" type="text/scss" rel="stylesheet/scss">
.refundDialog {
    .form{
        margin-top: 0;
    }
}
</style>
